import React, { useContext, useEffect, useState } from 'react';
import { IonContent, IonPage } from '@ionic/react';
import { Story } from '../../models/Story';
import Description from '../../components/Global/Description/Description';
import Header from '../../components/PlacePage/Header/Header';
import Grid from '../../components/PlacePage/Media/Grid';
import StoryMap from '../../components/StoryPage/StoryMap/StoryMap';
import Footer from '../../components/Global/Footer/Footer';
import StoryPlaces from '../../components/StoryPage/StoryPois/StoryPlaces';
import { useAppSelector } from '../../state/hooks';
import { RootState } from '../../state/store';
import { shallowEqual } from 'react-redux';
import FeaturedVideo from '../../components/Global/FeaturedVideo/FeaturedVideo';
import { StoryHelper } from '../../models/helpers/Helpers';
import { ExplorerContext } from '../../application/config';
import { useParams, useHistory } from 'react-router';
import { StoryFactory, StoryQuery } from '../../models/factories/StoryFactory';
import StoryTopNav from '../../components/Global/InnerPageComponents/StoryTopNav';
import ExternalUrl from '../../components/Global/ExternalUrl/ExternalUrl';
import FilteredCarousel from '../../components/PlacePage/Trails/TrailCarousel/Carousel';
import TrailsOnMap from '../../components/PlacePage/TrailsOnMap/TrailsOnMap';
import { selectPrefs } from '../../state/selectors';
import {
	filterPlacesByAccessibility,
	filterTrailsByAccessibility,
	sortPlacesByPreferences,
	sortTrailsByPreferences,
} from '../../models/helpers/preferenceRanking';
import { useMemo } from 'react';

type storyPageProps = {
	//	story: Story;
};

const StoryPage: React.FC<storyPageProps> = () => {
	const history = useHistory();
	const AppData = useContext(ExplorerContext);
	const { storyId } = useParams<{ storyId: string }>();
	const [ActiveStory, SetActiveStory] = useState<Story | undefined>(
		undefined,
	);
	console.log(ActiveStory);
	const network_status = useAppSelector(
		(state: RootState) => state.network.status,
		shallowEqual,
	);
	const userPrefs = useAppSelector(selectPrefs, shallowEqual);

	useEffect(() => {
		if (storyId) {
			const filterQuery: StoryQuery = {
				filter: { id: [Number(storyId)] },
			};
			const selectedStoryList = StoryFactory.filter(
				AppData.features?.all_stories ?? StoryFactory.getEmpty(),
				filterQuery,
			);
			if (selectedStoryList.stories.length > 0) {
				SetActiveStory(selectedStoryList.stories[0]);
			} else {
				SetActiveStory(undefined);
			}
		} else {
			SetActiveStory(undefined);
		}
	}, [storyId, AppData.features?.all_stories]);

	const prioritisedPlaces = useMemo(
		() =>
			ActiveStory
				? sortPlacesByPreferences(
					filterPlacesByAccessibility([...ActiveStory.places], userPrefs),
					userPrefs,
				)
				: [],
		[ActiveStory, userPrefs],
	);

	const prioritisedTrails = useMemo(
		() =>
			ActiveStory
				? sortTrailsByPreferences(
					filterTrailsByAccessibility([...ActiveStory.trails], userPrefs),
					userPrefs,
				)
				: [],
		[ActiveStory, userPrefs],
	);

	if (ActiveStory) {
		return (
			<IonPage>
				<IonContent fullscreen>
					<StoryTopNav storyId={ActiveStory.id} />
					<Header
						title={ActiveStory.title}
						image={ActiveStory.image}
						metaString={StoryHelper.generateMetaString(ActiveStory)}
					/>
					<main>
						<Description text={ActiveStory.description} />
						{ActiveStory.featured_video && (
							<FeaturedVideo src={ActiveStory.featured_video} />
						)}
						{network_status && ActiveStory.gallery && (
							<Grid media={ActiveStory.gallery} />
						)}

							{prioritisedPlaces.length > 0 && (
								<StoryMap places={prioritisedPlaces} />
							)}

							<StoryPlaces places={prioritisedPlaces} />

							{prioritisedTrails.length > 0 && (
								<>
									<FilteredCarousel
										items={prioritisedTrails}
									/>
									<TrailsOnMap trails={prioritisedTrails} />
								</>
							)}

						{ActiveStory.url && (
							<ExternalUrl
								url={ActiveStory.url}
								description={
									ActiveStory.external_url_description
								}
							/>
						)}
					</main>
					<Footer />
				</IonContent>
			</IonPage>
		);
	} else {
		return (
			<IonPage>
				<IonContent fullscreen>
					<main style={{ padding: '2rem', textAlign: 'center' }}>
						<h2>Story not found</h2>
						<p>This story may have been removed or is no longer available.</p>
						<button onClick={() => history.replace('/home')}>Go Home</button>
					</main>
				</IonContent>
			</IonPage>
		);
	}
};

export default StoryPage;
